export default "__VITE_ASSET__DZUowYVA__"